import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact-container">
        <div className="map hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3611.8100043021263!2d55.25794990882535!3d25.142113503631567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f658c19e118f1%3A0x6249e9201e8893cd!2sBath%20for%20less%20Trading%20L.L.C!5e0!3m2!1sen!2som!4v1687886906273!5m2!1sen!2som"
            style={{ borderRadius: "5px" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="address hidden">
          <h2>Address</h2>
          <p>
            Al Quoz Logistic Park, Al Quoz 2nd Industrial Area No.S05-605,
            Dubai, United Arab Emirates
          </p>
          <h2>Phone Number</h2>
          <p>
            <a href="tel:+971 43 858 784">+971 43 858 784</a>
          </p>
          <h2>Email Address</h2>
          <p>
            <a href="mailto:anas.baalbaki@bathforless.ae">
              anas.baalbaki@bathforless.ae
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
